export default __webpack_public_path__ + "static/creativelab-ab14e87b7280d258321513538012e0d7.png";